import { UnknownBlueprint } from '../types';

export const u5 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:5:unsupported');
	inBlueprint.schemaVersion = 5;
	return [inBlueprint, false];
};
